(() => {
  const init = (root = document) => {
    root.querySelectorAll('[data-sbj-scroll]').forEach((el) => {
      if (el.dataset.sbjBound === 'true') return;
      el.dataset.sbjBound = 'true';
      el.addEventListener('click', (event) => {
        const selector = el.getAttribute('href') || el.dataset.sbjScroll;
        if (!selector || !selector.startsWith('#')) return;
        const target = document.querySelector(selector);
        if (!target) return;
        event.preventDefault();
        const reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
        target.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'start' });
        if (target.matches('input, textarea, select, button, [tabindex]')) target.focus({ preventScroll: true });
      });
    });

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      root.querySelectorAll('video[autoplay]').forEach((video) => video.pause());
    }
  };

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', () => init());
  else init();

  document.addEventListener('shopify:section:load', (event) => init(event.target));
})();
